import React from 'react';
import { motion } from 'framer-motion';
import { useStory } from '../../context/StoryContext';

/**
 * NarrativeCaption — Small text beneath demos that explains the narrative significance
 * Fades in after demo completes: "Session 1 → Session 47. Same memory."
 * Respects prefers-reduced-motion
 *
 * Importers: src/pages/ICEPage.jsx (under MemoryVisualizer), src/pages/GoingMerryPage.jsx (under TensorCanvas) — planned
 * Affected API: Default export NarrativeCaption component
 * Data schema: Props accept text (string), delay (ms), className (string), style (object)
 * User instruction: "see this website is good... but the brand needs some kinda storytelling UI/UX... right? dont u think ? use ur marketing skills and make up a plan"
 */
const NarrativeCaption = ({
  text,
  delay = 2000,
  className = '',
  style,
  ...props
}) => {
  const { reducedMotion } = useStory();
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (reducedMotion) {
      setVisible(true);
      return;
    }
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay, reducedMotion]);

  if (!visible) return null;

  return (
    <motion.p
      className={`narrative-caption ${className}`}
      style={{
        fontSize: '0.8125rem',
        color: 'var(--text-muted)',
        textAlign: 'center',
        marginTop: '1.5rem',
        fontStyle: 'italic',
        letterSpacing: '0.01em',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto',
        ...style,
      }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      {...props}
    >
      {text}
    </motion.p>
  );
};

export default NarrativeCaption;